import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
import { trackPixelEvent } from './MetaPixel';
type Props = {
  label: string;
  sub?: string;
  size?: 'md' | 'lg';
  id?: string;
};
export function CtaButton({
  label,
  sub,
  size = 'md',
  id
}: Props) {
  return <div id={id} className="w-full flex flex-col items-center" data-id="element-27" data-mp="ckj5ve0683k4">
      <a href={CHECKOUT_URL} onClick={() => trackPixelEvent('InitiateCheckout')} className={`group w-full max-w-md inline-flex items-center justify-center gap-2 rounded-2xl bg-renal-500 text-white font-extrabold uppercase tracking-tight text-center shadow-[0_10px_0_0_#16693A] active:translate-y-1 active:shadow-[0_4px_0_0_#16693A] transition-all hover:bg-renal-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-renal-600 ${size === 'lg' ? 'px-5 py-5 text-[15px] sm:text-lg leading-tight' : 'px-5 py-4 text-[13.5px] sm:text-base leading-tight'}`} data-id="element-28" data-mp="cn5ab4rrm2y4">
        <span className="text-alert-500 text-lg leading-none" data-id="element-29" data-mp="35yz2wt2cn89y">●</span>
        <span data-id="element-30" data-mp="39zsv3ymtr98n">{label}</span>
        <ArrowRightIcon className="w-4 h-4 shrink-0 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-31" data-mp="39z17b9zgyfsx" />
      </a>
      {sub && <p className="mt-3 text-[11.5px] sm:text-xs text-navy-600/70 font-medium text-center px-2" data-id="element-32" data-mp="3jxqdi5i06btc">
          {sub}
        </p>}
    </div>;
}